import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HttpClientService } from './http-client.service';
import { UtilityService } from './utility.service';
import { BreadCrumbService } from '../ui-components/breadcrumb/breadcrumb.service';
import { AuthenticationService } from './authentication.service';
import { PageLoaderService } from '../ui-components/page-loader/page-loader.service';
import { ChipsService } from '../ui-components/chips/chips.service';

@Injectable()
export class CMSResolver implements Resolve<any> {
    public static cms = {
      global: { errors: {}
      }
    };

    constructor(
        private http: HttpClientService,
        private router: Router,
        private utilityService: UtilityService,
        private chipsService: ChipsService,
        private pageloaderService: PageLoaderService
    ) {
        this.updateCMS('global').subscribe(data => data, error => {
            console.log('global data not found');
        });
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        this.pageloaderService.setPageLoaderStatus(false);

        let context = route.data.context;
        if (!context) {
            const s = state.url.replace(/\//g, '')
            context = (s.indexOf('?') > 1) 
                ? s.substring(0, s.indexOf('?'))
                : s;
        }
      
        return this.updateCMS(context)
            .pipe(
       map(cms => {
                this.pageloaderService.setPageLoaderStatus(true);
                if (cms[context].title) {
                  document.title = cms[context].title;
                }
                if (cms[context].description) {
                  let meta = document.getElementsByTagName('meta');
                  meta['description'].content = cms[context].description;
                }
                this.chipsService.setChips(cms[context].chips);
                return cms;
            })
            ,catchError(error => {
                console.error(`Retrieval error: ${error.message}`);
                console.dir(error);
                this.pageloaderService.setPageLoaderStatus(true);
                this.router.navigate(['/error']);
                return of(null);
            }));
    }

    updateCMS(context): Observable<any> {
        let jsonData = CMSResolver.cms[context];
        jsonData = (jsonData) ? jsonData : JSON.parse(sessionStorage.getItem(context));
        const observableData = (jsonData) ? of(jsonData) :
                                            this.getFromMongo(context);
        return observableData.pipe(
       map(cmsData => {
            sessionStorage.setItem(context, JSON.stringify(cmsData));
            CMSResolver.cms[context] = cmsData;
            return CMSResolver.cms;
        }));
    }
    getFromMongo(context): Observable<any> {
        return this.http.authorizedGet('restservices/cms/v1/document/' + context)
            .pipe(
       map(mongoData => mongoData.body));
    }
}
